import { gql } from '@apollo/client';
import LICENSE_USAGE_FRAGMENT from 'graph/fragments/license-usage';

const GET_LICENSE_DATA = gql`
  query getLicenseData {
    mastercodes(where: { expired: false }) {
      id
      status
      orderItems {
        id
        licenseType
        product {
          id
          code
        }
      }
    }
    organizations(orderBy: { field: NAME, direction: ASC }) {
      id
      name
      parentOrganizationId
      rootOrganization {
        id
        ...OrganizationLicenseUsage
      }
      ...OrganizationLicenseUsage
    }
  }
  ${LICENSE_USAGE_FRAGMENT}
`;

export default GET_LICENSE_DATA;
